/* eslint-disable no-magic-numbers */

import {
	dimensions,
	duration,
	filesize
} from "widgets/forms/validators/Assets";
import { requiredAsset } from "social/validators/validators";
import { SECONDS_PER_MIN } from "utils/common";
import {
	isProtocolOptionalURL,
	isURL,
	maxLength,
	requiredNotNull
} from "widgets/forms/validators/validators";

import {
	MAX_VIDEO_BYTES,
	MAX_LENGTH_LANDING_PAGE,
	MAX_VIDEO_MIN,
	MIN_VIDEO_SEC
} from "./consts";

export const validators = {
	video: [
		requiredAsset,
		filesize({ max: MAX_VIDEO_BYTES }),
		dimensions({ minWidth: 120, minHeight: 120 }),
		duration({
			min: MIN_VIDEO_SEC,
			max: MAX_VIDEO_MIN * SECONDS_PER_MIN,
		})
	],
	landingPage: [
		requiredNotNull,
		isURL,
		maxLength(MAX_LENGTH_LANDING_PAGE),
	],
	displayLink: [isProtocolOptionalURL],
};
